<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="containerTestForm" :refresh-key="refreshKey" :show-expand="false" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                containerTestForm: () => import('../forms/ContainerTestForm'),
                headers: [
                    { text: 'Container', value: 'containerId', table: 'containers', form: () => import('../forms/ContainerForm') },
                    { text: 'Container Test Type', value: 'containerTestTypeId', table: 'containerTestTypes', form: () => import('../forms/ContainerTestTypeForm') },
                    { text: 'Sample Taken On', value: 'sampleTakenOn', format: this.formatDate },
                    { text: 'Sent To Lab On', value: 'sentToLabOn', format: this.formatDate },
                    { text: 'Laboratory Name', value: 'laboratoryName' },
                    { text: 'Is Present', value: 'isPresent' },
                    { text: 'Report File', value: 'reportFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'HPTLC Results File', value: 'chromatographyResultsFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    containers: [],
                    containerTestTypes: [],
                    items: []
                },
                sorting: [
                    { column: "sampleTakenOn", direction: "descending" },
                    { column: "laboratoryName", direction: "ascending" },
                    { column: "containerId", direction: "ascending" },
                    { column: "containerTestTypeId", direction: "ascending" },
                ],
                itemsField: 'containerTests',
                editPageName: 'containerTest',
                apiMethod: 'ContainerTests',
                claimName: 'ContainerTests',
                formTitle: 'Container Test',
                excelTitle: 'Container Tests',
                hasEditPage: false,
            }
        },
    };
</script>
